"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCollectionContainers = undefined;

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _Dom = require("common/Dom");

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require("common/Constants");

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require("common/Helpers");

var _state = require("state");

var _state2 = _interopRequireDefault(_state);

var _Product = require("components/Product");

var _Product2 = _interopRequireDefault(_Product);

var _mixitup = require("mixitup");

var _mixitup2 = _interopRequireDefault(_mixitup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Collection container state
 * @param {String|Number} id - container id
 * @param {Number} pageLimit - amount of products per page (pagination)
 * @param {Number} requestLimit - amount of products per ajax request (pagination on collection.ajax-json)
 * @param {Number} productCount - amount of products in current collection
 * @param {Array {}} allProducts - all product data (collection.ajax-json)
 * @param {Array {}} products - current collection product data (collection.ajax-json)
 * @param {Array {}} activeProducts - active set of products modified by filters(not maxed by pageLimit)
 * @param {Array {}} visibleProducts - active set of products modified by filters + pagination (maxed by pageLimit)
 * @param {Obj []} activeFilters - acurrent filters by filter group <filter-group>: [...values]
 * @param {Number} activePage - current page of paginated results
 * @param {DOM} grid - product grid element
 * @param {MixItUp} mixer - mixitup configuration instance
 */
var getCollectionContainerData = function getCollectionContainerData(collectionContainer) {
  var id = collectionContainer.dataset.containerId;
  var pageLimit = parseInt(collectionContainer.dataset.pageLimit);
  var productCount = collectionContainer.dataset.productCount;
  var allProductsCount = window.bvaccel.state.collection.allProductsCount;
  var allProducts = false;
  var products = false;
  var activeProducts = false;
  var visibleProducts = false;
  var activeFilters = {};
  var activeSort = false;
  var activePage = parseInt((0, _Helpers.getSearchParam)("page")) || 1;
  var requestLimit = 1000;
  var grid = collectionContainer.querySelector(_Dom2.default.productGrid);
  var mixer = (0, _mixitup2.default)(grid, {
    data: {
      uidKey: "id"
    },
    load: {
      dataset: window.bvaccel.initialProductJSON
    },
    render: {
      target: _Product2.default.renderGridItem
    },
    selectors: {
      target: _Dom2.default.mixitupItem
    },
    animation: {
      duration: 250,
      nudge: true,
      reverseOut: true,
      effects: "fade scale(0.01)"
    }
  });
  return {
    id: id,
    change: "collection",
    container: "collection",
    pageLimit: pageLimit,
    requestLimit: requestLimit,
    productCount: productCount,
    allProductsCount: allProductsCount,
    allProducts: allProducts,
    products: products,
    activeProducts: activeProducts,
    activeFilters: activeFilters,
    activePage: activePage,
    grid: grid,
    mixer: mixer
  };
};

var getSortHistory = function getSortHistory() {
  var url = new URL(window.location.href);
  if (url.searchParams.has('sort')) {
    return url.searchParams.get('sort');
  } else {
    url.searchParams.append('sort', 'featured');
    return "featured";
  }
};

var getFiltersHistory = function getFiltersHistory() {
  var urlParams = new URLSearchParams(window.location.search);
  var url = new URL(window.location.href);
  var filters = {};

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(urlParams.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (urlParams.has(key) && key !== 'page' && key !== 'sort') {
        // Check for Filter only Params
        if (key === 'Jewelry Type' || key === 'Designers' || key === 'Materials' || key === 'Gemstones' || key === 'Price Range') {
          if (filters.hasOwnProperty(key)) {
            var group = filters[key];
            group.push(value);
            filters[key] = group;
          } else {
            filters[key] = [value];
          }
          url.searchParams.delete(key);
          window.history.pushState('', '', url.href);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return filters;
};

var getCollectionProducts = function getCollectionProducts(products) {
  var collectionHandle = window.bvaccel.collection.handle;
  var preFilter = window.bvaccel.collection.currentTag;
  return products.filter(function (product) {
    if (preFilter) {
      return product.filters.includes(preFilter) && product.collections.includes(collectionHandle);
    }
    return product.collections.includes(collectionHandle);
  });
};

var getAllCollectionContainerData = function getAllCollectionContainerData() {
  return $(_Dom2.default.collectionContainer).get().map(getCollectionContainerData);
};

var initCollectionContainers = exports.initCollectionContainers = function initCollectionContainers(data) {
  return getAllCollectionContainerData().map(function (item) {
    _state2.default.set(item);
    _Product2.default.getAllProductsData(item).then(function (allProducts) {
      var activeSort = getSortHistory();
      var products = activeSort ? sortProductsBy([].concat((0, _toConsumableArray3.default)(allProducts)), activeSort) : allProducts;
      var change = "init";
      var container = "collection";
      return _state2.default.set((0, _assign2.default)({}, item, {
        change: change,
        container: container,
        products: products,
        activeProducts: products
      }));
    }).then(function (state) {
      return state;
    }).then(hydrate).then(function (state) {
      bindUIActions();
      state.mixer.dataset(state.visibleProducts).then(displayFilterOptions).then(hideLoader).then(function (data) {
        // build a list of all vendors with available products in the collection
        var availableVendors = state.products.reduce(function (vendors, product) {
          vendors[product.vendor] = true;
          return vendors;
        }, {});
        // now remove any vendor not in the list of available vendors
        var filterItems = document.querySelectorAll("[data-filter-group=\"Designers\"] .filter__input");
        var filterListEl = document.querySelector("[data-filter-group=\"Designers\"] .filter__items");
        filterItems.forEach(function (item) {
          if (!(item.getAttribute('name') in availableVendors)) {
            var parent = item.parentNode;
            filterListEl.removeChild(parent);
          }
        });
      });
    }).catch(function (err) {
      console.log("initCollectionContainers Error!", err);
    });
  });
};

var displayFilterOptions = function displayFilterOptions() {
  $('[data-filters-container]').addClass('is-active');
};

var hideLoader = function hideLoader() {
  $(_Dom2.default.paginationLoading).addClass('hide');
};

var getPaginationButton = function getPaginationButton(index, activePage) {
  var activeClass = index === parseInt(activePage) ? "is-active" : "";
  return "<li class=\"pagination__item\"><button class=\"pagination__btn " + activeClass + "\" data-paginate=\"" + index + "\">" + index + "</button></li>";
};

var getPagination = function getPagination(state) {
  var _state$activeProducts = state.activeProducts,
      products = _state$activeProducts === undefined ? [] : _state$activeProducts,
      pageLimit = state.pageLimit,
      activePage = state.activePage;

  if (products.length) {
    var pageCount = (0, _Helpers.getPageCount)(products.length, pageLimit);
    if (pageCount > 1) {
      var html = "<ul class=\"pagination__items\">";

      // Left Arrow
      activePage !== 1 ? html += "<li class=\"pagination__arrow left active\"><button class=\"pagination__btn\" data-paginate=\"" + (activePage - 1) + "\"></button></li>" : "<li class=\"pagination__arrow left \"><button class=\"pagination__btn\"></button></li>";

      var isFirstFive = activePage < 5 ? true : false;
      var isLastFive = false;
      if (pageCount > 5) {
        isLastFive = activePage > pageCount - 5 ? true : false;
      }
      var paginationItems = [];

      if (pageCount > 6) {
        if (isFirstFive) {
          paginationItems = [1, 2, 3, 4, 5, "...", pageCount];
        } else if (isLastFive) {
          paginationItems = [1, "...", pageCount - 4, pageCount - 3, pageCount - 2, pageCount - 1, pageCount];
        } else {
          paginationItems = [1, "...", parseInt(activePage) - 1, parseInt(activePage), parseInt(activePage) + 1, "...", pageCount];
        }

        paginationItems.forEach(function (page) {
          html += getPaginationButton(page, activePage);
        });
      } else {
        for (var i = 1; i <= pageCount; i++) {
          html += getPaginationButton(i, activePage);
        }
      }

      // Right Arrow
      activePage !== pageCount ? html += "<li class=\"pagination__arrow right active\"><button class=\"pagination__btn\" data-paginate=\"" + (activePage + 1) + "\"></button></li>" : "<li class=\"pagination__arrow right\"><button class=\"pagination__btn\"></button></li>";

      html += "</ul>";

      html += "<div class=\"pagination__product-count\">You've seen " + activePage * pageLimit + " of " + products.length + " products.</div>";

      return html;
    }
  }
  return "";
};

var buildPagaination = function buildPagaination(html) {
  $(_Dom2.default.pagination).html(html);
};

var applyPagination = function applyPagination(state) {
  var activeProducts = state.activeProducts,
      activePage = state.activePage,
      pageLimit = state.pageLimit;
  // const startingIndex = (activePage - 1) * (pageLimit + 1);

  var startingIndex = (activePage - 1) * pageLimit;
  var endingIndex = startingIndex + pageLimit;
  var activeSet = activeProducts.slice(startingIndex, endingIndex);
  return activeSet;
};

var updateActiveFilterCount = function updateActiveFilterCount(filters) {
  if ((0, _keys2.default)(filters).length) {
    $(_Dom2.default.filterCount).text("(" + (0, _keys2.default)(filters).length + ")");
  }
};

var updateActiveFilterList = function updateActiveFilterList(filters) {
  var html = "";
  if ((0, _keys2.default)(filters).length) {
    var htmlArray = (0, _keys2.default)(filters).map(function (filterGroup) {
      return filters[filterGroup].map(function (filter) {
        var filterName = $("[data-filter][value=\"" + filter + "\"]").attr("name");
        return "<li class=\"filters__active-item\"><button class=\"filters__active-item-btn\" data-filter-disable=\"" + filter + "\" title=\"remove\">" + filterName + "</button></li>";
      });
    });
    html = (0, _Helpers.flattenMultidimensionalArray)(htmlArray).join("");
  }
  $("[data-active-filters]").html(html);
};

var updateActiveFilters = function updateActiveFilters(state, group, value) {
  var enable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var clear = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var activeFilters = state.activeFilters;

  var filters = (0, _assign2.default)({}, activeFilters);
  var url = new URL(window.location.href);
  var filterGroupArray = filters[group] || false;
  if (filterGroupArray) {
    if (enable) {
      // Add value
      filters[group].push(value);
      var uniqueArray = new _set2.default(filters[group]);
      filters[group] = [].concat((0, _toConsumableArray3.default)(uniqueArray));

      // Add Search Param
      url.searchParams.append(group, value);
      window.history.pushState('', '', url.href);
    } else {
      // Remove value
      var valueIndex = filters[group].indexOf(value);
      var groupParams = url.searchParams.getAll(group);

      // Remove Search Params
      url.searchParams.delete(group);
      window.history.pushState('', '', url.href);
      groupParams.splice(valueIndex, 1);

      if (groupParams.length >= 1) {
        groupParams.map(function (value) {
          url.searchParams.append(group, value);
          window.history.pushState('', '', url.href);
        });
      }

      filters[group].splice(valueIndex, 1);
      if (!filters[group].length) {
        delete filters[group];
      }
    }
  } else if (clear) {
    var _url = new URL(window.location.href);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(_url.searchParams.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _ref3 = _step2.value;

        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2);

        var key = _ref4[0];
        var _value = _ref4[1];

        if (_url.searchParams.has(key) && key !== 'page' && key !== 'sort') {
          _url.searchParams.delete(key);
          window.history.pushState('', '', _url.href);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    filters = {};
  } else {
    // Create array with single value
    filters[group] = [value];
    var _uniqueArray = new _set2.default(filters[group]);
    filters[group] = [].concat((0, _toConsumableArray3.default)(_uniqueArray));

    url.searchParams.append(group, value);
    window.history.pushState('', '', url.href);
  }

  if (!(0, _keys2.default)(filters).length) {
    filters = {};
  }

  updateActiveFilterList(filters);
  updateActiveFilterCount(filters);
  var change = "active_filters";
  var container = "collection";
  return _state2.default.set((0, _assign2.default)({}, state, { change: change, container: container, activeFilters: filters }));
};

var updateActiveSort = function updateActiveSort(state, sort) {
  var change = "active_sort";
  var container = "collection";

  var url = new URL(window.location.href);
  url.searchParams.delete('sort');
  url.searchParams.append('sort', sort);
  window.history.pushState('', '', url.href);

  return _state2.default.set((0, _assign2.default)({}, state, { change: change, container: container, activeSort: sort }));
};

var updateFilteredProducts = function updateFilteredProducts(state) {
  var activeFilters = state.activeFilters,
      products = state.products;

  var filteredProducts = [].concat((0, _toConsumableArray3.default)(products));
  if (activeFilters && (0, _keys2.default)(activeFilters).length) {
    (0, _keys2.default)(activeFilters).forEach(function (filterGroup) {
      filteredProducts = filteredProducts.filter(function (_ref5) {
        var filters = _ref5.filters;

        return activeFilters[filterGroup].some(function (activeFilter) {
          return filters.indexOf(activeFilter) >= 0;
        });
      });
    });
  }
  var change = "active_products";
  var container = "collection";
  return _state2.default.set((0, _assign2.default)({}, state, {
    change: change,
    container: container,
    activeProducts: filteredProducts
  }));
};

var sortProductsBy = function sortProductsBy(sortedProducts, sortBy) {
  console.log('SORTBY', sortBy);
  switch (sortBy) {
    case "newest-arrivals":
      sortedProducts.sort(sortByNewest);
      break;
    case "featured":
      sortedProducts.sort(sortByShopifyDefault);
      break;
    case "price-low-high":
      sortedProducts.sort(function (a, b) {
        return sortByPrice(a, b);
      });
      break;
    case "price-high-low":
      sortedProducts.sort(function (a, b) {
        return sortByPrice(b, a);
      });
      break;
  }
  return sortedProducts;
};

var updateSortedProducts = function updateSortedProducts(state) {
  var activeSort = state.activeSort,
      products = state.products;

  if (activeSort) {
    var sortedProducts = sortProductsBy([].concat((0, _toConsumableArray3.default)(products)), activeSort);
    var change = "products";
    var container = "collection";
    return _state2.default.set((0, _assign2.default)({}, state, {
      change: change,
      container: container,
      products: sortedProducts
    }));
  }
  return state;
};

var sortByNewest = function sortByNewest(a, b) {
  return new Date(b.publish_date) - new Date(a.publish_date);
};

var sortByShopifyDefault = function sortByShopifyDefault(a, b) {
  return a.default_sort_index - b.default_sort_index;
};

var sortByPrice = function sortByPrice(a, b) {
  return a.price - b.price;
};

var updatePage = function updatePage(state, page) {
  var change = "active_page";
  var container = "collection";
  (0, _Helpers.setSearchParm)("page", page);
  return _state2.default.set((0, _assign2.default)({}, state, { change: change, container: container, activePage: page }));
};

var getContainerState = function getContainerState(event) {
  var id = $(_Dom2.default.container).attr("data-container-id");

  if (event) {
    var $this = $(event.currentTarget);
    var $container = $this.closest(_Dom2.default.container);
    id = $container.attr("data-container-id");
  }

  return _state2.default.get(id);
};

var updateCollection = function updateCollection(state) {
  $(_Dom2.default.productGrid).removeClass("is-empty");
  var paginationHTML = getPagination(state);
  buildPagaination(paginationHTML);
  var products = applyPagination(state);
  state.mixer.dataset(products);
  if (!products.length) {
    $(_Dom2.default.productGrid).addClass("is-empty");
  }
  var change = "visible_products";
  var container = "collection";
  return _state2.default.set((0, _assign2.default)({}, state, { change: change, container: container, visibleProducts: products }));
};

var toggleLoadingScreen = function toggleLoadingScreen() {
  return $(_Dom2.default.productGrid).toggleClass("is-loading");
};

var hydrate = function hydrate(state) {
  var hydratedState = state;
  var activeFilters = getFiltersHistory();
  var activeSort = getSortHistory();

  $("" + _Dom2.default.sort).attr('checked', false);

  $(_Dom2.default.sort + "[value=\"" + activeSort + "\"]").prop('checked', true);
  $(_Dom2.default.sort + "[value=\"" + activeSort + "\"]").attr('checked', true);

  hydratedState = updateSortedProducts(hydratedState);

  var _loop = function _loop(key, value) {
    var group = key;
    value.forEach(function (filterValue) {
      $(_Dom2.default.filter + "[value=\"" + filterValue + "\"]").prop('checked');
      $(_Dom2.default.filter + "[value=\"" + filterValue + "\"]").attr('checked', true);

      hydratedState = updateActiveFilters(hydratedState, group, filterValue, true);
    });
    hydratedState = updateFilteredProducts(hydratedState);
  };

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(activeFilters)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref6 = _step3.value;

      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2);

      var key = _ref7[0];
      var value = _ref7[1];

      _loop(key, value);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  hydratedState = updateCollection(hydratedState);
  return hydratedState;
};

var bindUIActions = function bindUIActions() {
  $(document).on("click", _Dom2.default.paginate, function (event) {
    var $this = $(event.currentTarget);
    var pageNumber = parseInt($this.attr("data-paginate"));
    var state = getContainerState(event);
    state = updatePage(state, pageNumber);
    $(_Dom2.default.screen).animate({ scrollTop: 0 }, 300);
    updateCollection(state);
  });

  $(document).on("change", _Dom2.default.filter, function (event) {
    var $this = $(event.currentTarget);
    var $group = $this.closest(_Dom2.default.filterGroup);
    var value = $this.val();
    var group = $group.attr("data-filter-group");
    var isActive = $this.is(":checked");
    var state = getContainerState(event);
    state = updateActiveFilters(state, group, value, isActive);
    state = updateFilteredProducts(state);
    state = updatePage(state, 1); // reset back to one every time a filter is changed
    updateCollection(state);
  });

  $(document).on("change", _Dom2.default.sort, function (event) {
    var $this = $(event.currentTarget);
    var value = $this.val();
    var state = getContainerState(event);
    state = updateActiveSort(state, value);
    state = updateSortedProducts(state);
    state = updateFilteredProducts(state);
    state = updatePage(state, 1); // reset back to one every time a sort is changed
    updateCollection(state);
  });

  $(document).on("click", _Dom2.default.filterDisable, function (event) {
    var $this = $(event.currentTarget);
    var filter = $this.attr("data-filter-disable");
    $("[data-filter][value=\"" + filter + "\"]").removeProp("checked").trigger("change");
  });

  $(document).on("click", _Dom2.default.filterToggle, function (event) {
    var $this = $(event.currentTarget);
    var $filterContainer = $this.closest(_Dom2.default.filterGroup);
    $filterContainer.toggleClass("is-open");
  });

  $(document).on("click", _Dom2.default.typeToggle, function (event) {
    var $this = $(event.currentTarget);
    var type = $this.attr("data-type-toggle");
    var $subjects = $this.siblings("[data-filter-type=\"" + type + "\"]");
    $subjects.slideToggle(300);
    $this.toggleClass("is-open");
  });

  $(document).on('click', _Dom2.default.filterClear, function (event) {
    var state = getContainerState(event);
    state = updateActiveFilters(state, null, null, null, true);
    state = updateFilteredProducts(state);
    state = updatePage(state, 1); // reset back to one every time a filter is changed
    updateCollection(state);

    $(_Dom2.default.filterClear).addClass('hide');
    $('[data-filter-type="sort"]').removeClass('hide');

    $("" + _Dom2.default.filter).attr('checked', false);
  });

  $(window).on('scroll', function () {
    var scrollTop = window.scrollY;
    var filtersOffsetTop = $('[data-container]').offset().top;

    var state = getContainerState(false);
    var activeFilters = state.activeFilters;

    var filters = (0, _assign2.default)({}, activeFilters);

    if ((0, _keys2.default)(filters).length > 0) {
      if (scrollTop > filtersOffsetTop) {
        $(_Dom2.default.filterClear).removeClass('hide');
        $('[data-filter-type="sort"]').addClass('hide');
      } else if (scrollTop == 0) {
        $(_Dom2.default.filterClear).addClass('hide');
        $('[data-filter-type="sort"]').removeClass('hide');
      }
    }
  });
};